import { useAuth } from '../../contexts/AuthContext';
import { Card, Alert } from 'flowbite-react';
import {
  HiInformationCircle,
} from 'react-icons/hi';
import AdminLayout from '@/components/layout/AdminLayout';

export default function AdminSettings() {
  const { userProfile } = useAuth();

  if (!userProfile || userProfile.role !== 'superadmin') {
    return (
      <AdminLayout>
        <Card>
          <div className="p-6">
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Acceso Denegado</h3>
            <p className="text-gray-600 dark:text-gray-400">No tienes permisos para acceder a esta página</p>
          </div>
        </Card>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Configuración</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1">Configuración general del sistema</p>
        </div>

        <Alert color="info" icon={HiInformationCircle}>
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Configuración en Desarrollo</h3>
            <p className="text-sm text-gray-700 dark:text-gray-300">
              Esta sección está en desarrollo. Aquí se podrán configurar:
            </p>
            <ul className="mt-2 text-sm text-gray-700 dark:text-gray-300 list-disc list-inside space-y-1">
              <li>Configuración general del sistema</li>
              <li>Parámetros de seguridad</li>
              <li>Configuración de emails</li>
              <li>Integraciones con servicios externos</li>
              <li>Configuración de notificaciones</li>
            </ul>
          </div>
        </Alert>

        <Card className="bg-white dark:bg-gray-800">
          <div className="p-6">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">Información del Sistema</h2>
            <div className="space-y-3">
              <div>
                <p className="text-sm text-gray-600 dark:text-gray-400">Versión de la Aplicación</p>
                <p className="text-base font-medium text-gray-900 dark:text-white">1.0.0</p>
              </div>
              <div>
                <p className="text-sm text-gray-600 dark:text-gray-400">Base de Datos</p>
                <p className="text-base font-medium text-gray-900 dark:text-white">Supabase (PostgreSQL)</p>
              </div>
              <div>
                <p className="text-sm text-gray-600 dark:text-gray-400">Autenticación</p>
                <p className="text-base font-medium text-gray-900 dark:text-white">Supabase Auth (Email/Password + Google OAuth)</p>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </AdminLayout>
  );
}
